import { parseChildren, generateJsxKey } from '@utils/ast';
import { video23ToLatexPrinters, video23Parsers } from './spec.23video.js';
import Box from './spec.box.comp.js';
import { fontToLatexPrinters, fontParsers } from './spec.font.js';
import { iGuideHtmlNodeLatexPrinters, iGuideHtmlNodeParsers } from './spec.html.js';
import { imageToLatexPrinters, imageParsers } from './spec.image.js';
import { linkToLatexPrinters } from './spec.link.js';
import { medialibraryToLatexPrinters, medialibraryParsers } from './spec.medialibrary.js';
import { jsx } from 'react/jsx-runtime';

const parser = (node, context) => {
  const children = parseChildren(node, {
    ...iGuideHtmlNodeParsers,
    ...video23Parsers,
    ...medialibraryParsers,
    ...imageParsers,
    ...fontParsers
  }, context.depth + 1);
  const boxType = (() => {
    switch (node.tagName.toLowerCase()) {
      case "factbox":
        return "fact";
      case "quotebox":
        return "quote";
      case "questionbox":
        return "question";
    }
  })();
  return {
    nodeType: "box",
    boxType,
    children
  };
};
const boxParsers = {
  factbox: parser,
  quotebox: parser,
  questionbox: parser
};
const boxPrinters = {
  box: (node, context) => {
    return /*#__PURE__*/jsx(Box, {
      node: node,
      context: context
    }, generateJsxKey(context));
  }
};
const boxToLatexPrinters = {
  box: (node, context) => {
    const label = (() => {
      switch (node.boxType) {
        case "fact":
          return "Faktaboks";
        case "question":
          return "Spørgsmål";
        case "quote":
          return "Citat";
      }
    })();
    const content = context.printChildren(node.children, {
      ...iGuideHtmlNodeLatexPrinters,
      ...imageToLatexPrinters,
      ...video23ToLatexPrinters,
      ...medialibraryToLatexPrinters,
      ...fontToLatexPrinters,
      ...linkToLatexPrinters
    }).join("");
    return `\\noindent\\rule{\\textwidth}{1pt}
\\textbf{${label}} ${content}
\\noindent\\rule{\\textwidth}{1pt}\n`;
  }
};

export { boxParsers, boxPrinters, boxToLatexPrinters };
//# sourceMappingURL=spec.box.js.map
